const addThumbButtonsClickHandlers = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes();
  const scrollToIndex = slidesThumbs.map((_, index) => () => emblaApiMain.scrollTo(index));

  slidesThumbs.forEach((slideNode, index) => {
    slideNode.addEventListener("click", scrollToIndex[index], false);
  });

  return () => {
    slidesThumbs.forEach((slideNode, index) => {
      slideNode.removeEventListener("click", scrollToIndex[index], false);
    });
  };
};

const addToggleThumbButtonsActive = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes();
  const classSelected = "c-embla-thumbnails__item--selected";

  const toggleThumbBttonsState = () => {
    emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
    const previous = emblaApiMain.previousScrollSnap();
    const selected = emblaApiMain.selectedScrollSnap();
    slidesThumbs[previous].classList.remove(classSelected);
    slidesThumbs[selected].classList.add(classSelected);
  };

  emblaApiMain.on("select", toggleThumbBttonsState);
  emblaApiThumb.on("init", toggleThumbBttonsState);

  return () => {
    const selected = emblaApiMain.selectedScrollSnap();
    slidesThumbs[selected].classList.remove(classSelected);
  };
};

export { addThumbButtonsClickHandlers, addToggleThumbButtonsActive };
